/*
 * Copyright 2022 Nightingale Team
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

export const pageSizeOptionsDefault = ['30', '50', '100', '300'];

export const timeLensDefault = [
  {
    value: '1h',
  },
  {
    value: '2h',
  },
  {
    value: '3h',
  },
  {
    value: '6h',
  },
  {
    value: '12h',
  },
  {
    value: '1d',
  },
  {
    value: '2d',
  },
  {
    value: '3d',
  },
  {
    value: '5d',
  },
  {
    value: '7d',
  },
  {
    value: '14d',
  },
  {
    value: '30d',
  },
  {
    value: '60d',
  },
  {
    value: '90d',
  },
  {
    value: '99y',
  },
];
